import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DetalhamentoPrazos extends Component {

    static propTypes = {
        momentDataInicio: PropTypes.object,
        momentDataTermino: PropTypes.object,
        quantidadeRecursos: PropTypes.number,
        isSolicitacaoProrrogacao: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        const desabilitarValidacao = _.get(this.props, "desabilitarValidacao", false);
        const solicitacao = this.props.controller.solicitacao;
        const dataInicioProrrogacao = this.props.controller.dataInicioProrrogacao;
        const quantidadeDias = this.props.controller.quantidadeDias;
        const quantidadeDiasProrrogacao = this.props.controller.quantidadeDiasProrrogacao;
        const exibeQuantidadeRecursos = this.props.controller.exibeQuantidadeRecursos;
        const exibeDadosProrrogacao = this.props.controller.exibeDadosProrrogacao;
        const momentDataTerminoProrrogacao = this.props.controller.momentDataProrrogacao;
        const dataProrrogacaoMin = this.props.controller.dataProrrogacaoMin;
        const dataProrrogacaoMax = this.props.controller.dataProrrogacaoMax;
        const tarefaMudarDataIncio = this.props.controller.tarefaPermiteAlterarDataInicio;// && (_.get(solicitacao, "momentDataInicio") ?
            //(moment(_.get(solicitacao, "momentDataInicio")) >= moment().startOf('day')) : true);

        return (
            <div>
                <h4>Prazos e quantidade</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        { tarefaMudarDataIncio ?
                            <FormGroup>
                                <Label>Data de início</Label>
                                <DatePicker
                                    ref="dataInicio"
                                    onClickOutside={() => {
                                        this.refs.dataInicio.cancelFocusInput();
                                        this.refs.dataInicio.setOpen(false);
                                    }}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsStart
                                    selected={moment(_.get(solicitacao, "momentDataInicio"))}
                                    minDate={moment()}
                                    onChange={(value) => this.props.controller.setMomentDataInicio(value)}
                                    onBlur={(e) => this.props.controller.setDataInicioCheck(e.target.value)}/>
                                {!desabilitarValidacao && <Validacao id="dataInicio" valor={this.props.controller.dataInicioValidacao}
                                           tipo={["isRequired","isDate",
                                               "compararDataAnterior", moment().format("DD/MM/YYYY")]}/>}
                            </FormGroup> :
                            <FormGroup>
                                <Label>Data de início</Label>
                                <Input className="form-control" type="text" value={moment(_.get(solicitacao, "momentDataInicio")).format("DD/MM/YYYY")} readOnly/>
                            </FormGroup> }
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Data de término</Label>
                            <Input className="form-control" type="text" value={moment(_.get(solicitacao, "momentDataTermino")).format("DD/MM/YYYY") || ""} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Quantidade dias</Label>
                            <Input type="number" value={quantidadeDias} readOnly/>
                        </FormGroup>
                    </Col>
                    {exibeQuantidadeRecursos &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Quantidade MOT</Label>
                                <Input type="number" value={_.get(solicitacao, "quantidadeRecursos")} readOnly/>
                            </FormGroup>
                        </Col>
                    }
                </Row>
            </div>
        )
    }
}